"use client"

import { RadioTower } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RadioTowerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RadioTowerIcon = component(Icon)({ as: RadioTower })
